import env from './env';

function configureOrigin(envName: string) {
  const config = {
    apiOrigin: '',
    proxyOrigin: '',
    iframeOrigin: '',
    reCAPTCHASiteKey: '6LeHEeUcAAAAAFsVnCRMWstK0fHaOhHsh2OfkLTw',
    redirectSuspendedUserUrl: '',
    creditCardPageAuth: '',
    gcpClientId: '',
    zendeskWidgetKey: '',
    zendeskSubDomain: '',
  };

  switch (envName) {
    case 'production':
      config.apiOrigin = 'https://api.guestyforhosts.com/';
      config.proxyOrigin = 'https://app.guestyforhosts.com/api/v1';
      config.iframeOrigin = 'https://frame.guestyforhosts.com/#/authenticated';
      config.redirectSuspendedUserUrl =
        'https://billing.guestyforhosts.com/auth?userId={userId}';
      config.creditCardPageAuth = 'https://billing.guestyforhosts.com/auth';
      config.gcpClientId =
        '1046481227814-f8fuc27ac5l91lndmrgrkk9pcdu9kh1d.apps.googleusercontent.com';
      config.zendeskWidgetKey = '71d40f5e-3272-4140-96d4-08120d20d32d';
      config.zendeskSubDomain = 'guesty3396';
      break;
    case 'staging':
    case 'staging1':
    case 'staging2':
    case 'staging3':
    case 'staging4':
    case 'staging5':
    case 'staging6':
    case 'staging7':
    case 'staging8':
    case 'staging9':
    case 'staging10':
    case 'preprod':
    case 'sandbox':
      config.apiOrigin = 'https://apidev.guestyforhosts.com';
      config.proxyOrigin = '/api/v1';
      config.iframeOrigin =
        'https://frame-dev.guestyforhosts.com/#/authenticated';
      config.redirectSuspendedUserUrl =
        'https://billing-staging1.guestyforhosts.com/auth?userId={userId}';
      config.gcpClientId =
        '535440425652-k9m6jkff24vselntnv0icv96uo3a9vin.apps.googleusercontent.com';
      config.creditCardPageAuth =
        'https://billing-staging1.guestyforhosts.com/auth';
      config.zendeskWidgetKey = '5a293c8d-a59b-4d8d-9709-a133634db8a3';
      config.zendeskSubDomain = 'guesty33961681113172';
      break;
    default:
      console.log('Got to default in configureOrigin statement');
  }

  return config;
}

export default configureOrigin(env);
